import React, { useState } from "react";
import Dialog from "./ui/Dialog";
import OtpInput from "./ui/OtpInput";

const LoginPaidForSignup = ({ isOpen, onClose, onVerifySuccess }) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState(Array(6).fill("")); // OTP input state
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [otpErrorMessage, setOTPErrorMessage] = useState("");
  const [otpsuccessMessage, setOTPSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false); // Track if OTP has been sent
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const handleClose = () => {
    setPhoneNumber("");
    setOtp(Array(6).fill(""));
    setOtpSent(false);
    setErrorMessage("");
    setSuccessMessage("");
    setOTPErrorMessage("");
    setOTPSuccessMessage("");
    setLoading(false);

    onClose(); // call parent close
  };
  if (!isOpen) return null;

  // Handle sending phone number for OTP
  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    if (phoneNumber.length !== 10) {
      setErrorMessage("Phone number must be exactly 10 digits");
      return;
    }
    setLoading(true); // Show loader
    try {
      const response = await fetch(`${BASE_URL}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "https://api.bossinvestor.in",
          "Access-Control-Allow-Credentials": "true",
        },
        body: JSON.stringify({ phoneNumber }),
      });

      const result = await response.json();
      setLoading(false); // Hide loader

      // Check if the response is a success
      if (!response.ok) {
        const errorDetails =
          result.status?.errors?.phoneNumber || result.status.message;
        setErrorMessage(
          errorDetails || "Failed to send OTP. Please try again.",
        );
        return;
      }

      // If OTP request is successful, show OTP input fields
      setOtpSent(true);
      setErrorMessage("");
      setSuccessMessage("OTP sent successfully!");
    } catch (error) {
      setLoading(false); // Hide loader
      setErrorMessage(error.message || "An unexpected error occurred");
    }
  };

  // Handle OTP verification
  const handleOtpVerify = async (e) => {
    e.preventDefault();
    const otpCode = otp.join("");
    if (otpCode.length !== 6) {
      setOTPErrorMessage("OTP must be exactly 6 digits");
      return;
    }
    setLoading(true); // Show loader
    try {
      const response = await fetch(`${BASE_URL}/auth/verifyLoginOtp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "https://api.bossinvestor.in",
          "Access-Control-Allow-Credentials": "true",
        },
        body: JSON.stringify({ phoneNumber, otp: otpCode }),
      });

      const result = await response.json();
      setLoading(false); // Hide loader

      if (!response.ok || result?.status?.statusCode !== 200) {
        throw new Error(result?.status?.message || "OTP verification failed.");
      }
      window.sessionStorage.setItem("jwtToken", result.data.jwtToken);
      window.sessionStorage.setItem("refreshToken", result.data.refreshToken);

      setOTPSuccessMessage("Login successful!");
      setOTPErrorMessage("");
      setOTPSuccessMessage("OTP verified successfully!");

      onVerifySuccess(phoneNumber);
    } catch (error) {
      setLoading(false); // Hide loader
      setOTPErrorMessage(error.message || "OTP verification failed.");
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      title={otpSent ? "Mobile phone verification" : "Enter your mobile number"}
      subtitle={otpSent ? "Enter the 6-digit verification code that was sent to your mobile number" : undefined}
      titleId="signup-otp-title"
    >
      {!otpSent ? (
        <form onSubmit={handleLoginSubmit} className="fn-auth-form">
          <div className="fn-auth-phone">
            <span className="fn-auth-prefix fn-num" aria-hidden="true">+91</span>
            <input
              type="text"
              inputMode="numeric"
              autoComplete="tel-national"
              aria-labelledby="signup-otp-title"
              aria-invalid={errorMessage ? true : undefined}
              aria-describedby={errorMessage ? "signup-phone-error" : undefined}
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Mobile number"
              className="fn-field fn-num"
            />
          </div>
          <button type="submit" className="fn-btn fn-btn-primary fn-btn-block" disabled={loading}>
            {loading ? "Sending..." : "Send OTP"}
          </button>
          {errorMessage && (
            <p className="fn-error" id="signup-phone-error" role="alert">
              {errorMessage}
            </p>
          )}
          {successMessage && (
            <p className="fn-success" role="status">
              {successMessage}
            </p>
          )}
        </form>
      ) : (
        <div className="fn-auth-form">
          <OtpInput length={6} otp={otp} setOtp={setOtp} labelledBy="signup-otp-title" />
          <button
            type="button"
            className="fn-btn fn-btn-primary fn-btn-block"
            onClick={handleOtpVerify}
            disabled={loading}
          >
            {loading ? "Verifying..." : "Verify OTP"}
          </button>
          {otpErrorMessage && (
            <p className="fn-error" role="alert">
              {otpErrorMessage}
            </p>
          )}
          {otpsuccessMessage && (
            <p className="fn-success" role="status">
              {otpsuccessMessage}
            </p>
          )}
        </div>
      )}
    </Dialog>
  );
};

export default LoginPaidForSignup;
